/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentScenarioControllerRemoveMutationResponse, IncidentScenarioControllerRemovePathParams } from "../../models/incidentAgentController/IncidentScenarioControllerRemove";

function getIncidentScenarioControllerRemoveUrl(id: IncidentScenarioControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/incident-agent/scenarios/${id}` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/scenarios/:id}
 */
export async function incidentScenarioControllerRemove(id: IncidentScenarioControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentScenarioControllerRemoveMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getIncidentScenarioControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}